"use client";

import React from "react";
import Image from "next/image";

interface InsuranceImage {
  image: string;
  alt: string;
  order: number;
  url: string;
}

const insuranceImages: InsuranceImage[] = [
  {
    image:
      "/images/american-academy-of-implant-dentistry-logo-in-purple-and-blue-on-transparent-background.webp",
    alt: "american-academy-of-implant-dentistry-logo-in-purple-and-blue-on-transparent-background",
    order: 1,
    url: "https://www.aaid.com/",
  },
  {
    image:
      "/images/american-dental-association-logo-in-bold-green-uppercase-letters-with-black-text-underneath-on-transparent-background.webp",
    alt: "american-dental-association-logo-in-bold-green-uppercase-letters-with-black-text-underneath-on-transparent-background",
    order: 2,
    url: "https://www.ada.org/",
  },
  {
    image:
      "/images/academy-of-general-dentistry-logo-with-gray-blue-and-orange-text-and-abstract-bridge-design-on-transparent-background.webp",
    alt: "academy-of-general-dentistry-logo-with-gray-blue-and-orange-text-and-abstract-bridge-design-on-transparent-background",
    order: 3,
    url: "https://www.agd.org/",
  },
  {
    image:
      "/images/care-credit-logo-with-green-leaf-shaped-icon-and-dark-teal-text-on-transparent-background.webp",
    alt: "care-credit-logo-with-green-leaf-shaped-icon-and-dark-teal-text-on-transparent-background",
    order: 4,
    url: "https://www.carecredit.com/",
  },
  {
    image:
      "/images/trios-by-3shape-logo-with-dark-blue-text-and-red-triangle-icon-on-transparent-background.webp",
    alt: "trios-by-3shape-logo-with-dark-blue-text-and-red-triangle-icon-on-transparent-background",
    order: 5,
    url: "https://www.3shape.com/en-us/scanners/trios",
  },
  {
    image:
      "/images/aetna-logo-in-purple-text-with-heart-shaped-icon-on-transparent-background.webp",
    alt: "aetna-logo-in-purple-text-with-heart-shaped-icon-on-transparent-background",
    order: 6,
    url: "https://www.aetna.com/",
  },
  {
    image:
      "/images/bluecross-blueshield-logo-with-blue-cross-and-blue-shield-icons-next-to-black-text-on-transparent-background.webp",
    alt: "bluecross-blueshield-logo-with-blue-cross-and-blue-shield-icons-next-to-black-text-on-transparent-background",
    order: 7,
    url: "https://www.bcbs.com/",
  },
  {
    image:
      "/images/cigna-logo-with-blue-text-and-tree-shaped-human-figure-made-of-green-leaves-and-orange-dot-on-transparent-background.webp",
    alt: "cigna-logo-with-blue-text-and-tree-shaped-human-figure-made-of-green-leaves-and-orange-dot-on-transparent-background",
    order: 8,
    url: "https://www.cigna.com/",
  },
  {
    image:
      "/images/delta-dental-logo-with-green-triangle-icon-and-bold-uppercase-green-text-on-transparent-background.webp",
    alt: "delta-dental-logo-with-green-triangle-icon-and-bold-uppercase-green-text-on-transparent-background",
    order: 9,
    url: "https://www.deltadental.com/",
  },
  {
    image:
      "/images/guardian-logo-with-dark-blue-text-and-interlocking-green-and-blue-letter-g-symbol-on-transparent-background.webp",
    alt: "guardian-logo-with-dark-blue-text-and-interlocking-green-and-blue-letter-g-symbol-on-transparent-background",
    order: 10,
    url: "https://www.guardianlife.com/",
  },
  {
    image:
      "/images/metlife-logo-with-black-text-and-blue-green-overlapping-M-design-on-transparent-background.webp",
    alt: "metlife-logo-with-black-text-and-blue-green-overlapping-M-design-on-transparent-background",
    order: 11,
    url: "https://www.metlife.com/",
  },
  {
    image:
      "/images/united-healthcare-logo-in-dark-blue-text-with-curved-stripe-symbol-on-transparent-background.webp",
    alt: "united-healthcare-logo-in-dark-blue-text-with-curved-stripe-symbol-on-transparent-background",
    order: 12,
    url: "https://www.uhc.com/",
  },
];

const chunk = <T,>(arr: T[], size: number): T[][] =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const rows = chunk(insuranceImages, 6);

const InsuranceLogos: React.FC = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4 space-y-8">
        {rows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4"
          >
            {row.map((item, idx) => (
              <a
                key={idx}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:scale-105 transition-transform duration-300 min-h-[44px] min-w-[44px] focus:outline-none focus:ring-2 focus:ring-[#AE7D2F] focus:ring-opacity-50"
                aria-label={`Visit ${item.alt} website`}
              >
                <Image
                  src={item.image}
                  alt={item.alt}
                  width={180}
                  height={80}
                  className="object-contain"
                  sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 16vw"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default InsuranceLogos;
